<app-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_MODE_TILE' | translate"
  [overlayType]="availableOverlays.WallboxChargingSettings"
>
  <app-feature-tile
    *ngIf="chargingMode$ | async | ready as feature"
    data-at-cascade-dhw-mode
    feature
    isFullWidth="true"
    [isNgContent]="true"
    [attr.data-feature]="feature.feature"
  >
    <img class="icon" [src]="modeIconSource" />
    <p class="text-[14px] text-black">
      {{ modeLabel | translate }}
    </p>
    <p
      *ngIf="vehicleChargingStationAllowBatteryDischarge$ | async | ready as feature"
      class="text-[14px] font-semibold"
    >
      {{
        feature.properties?.active?.value
          | booleanSuffix
            : [
                customTranslationsService.WALLBOX_CHARGING_MODE.activated | translate,
                customTranslationsService.WALLBOX_CHARGING_MODE.deactivated | translate
              ]
      }}
    </p>
  </app-feature-tile>
  <app-feature-tile
    *ngIf="chargingLimit$ | async | ready as feature"
    data-at-cascade-dhw-mode
    feature
    isFullWidth="true"
    [label]="'+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT_TILE' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-features-container>
